<template>
  <section class="content" style="width: 80%;">
    <!-- Default box -->
    <div class="box">
      <!-- <div class="box-header with-border">
        <h3 class="box-title">Settings</h3>
      </div> -->
      <div class="box-body" id="html-template" style="height: 100%;min-height: 700px;">
        <!-- start tab -->
        <div class="row" id="pdfdocument">
              <div class="col-sm-12">
                <div>
                  <b-form class="register-form" id="resets" v-on:submit.prevent="onSubmitFeedback" novalidate>
                    <!-- <div class="col-md-12" style="padding: 29px">
                      <div class="form-row">
                        <label>TDD Code here</label>
                      </div>
                      <div class="form-row">
                          {{$v.form.TDD_code.$model}}
                      </div>
                    </div> -->
                    <div class="col-md-12" style="padding: 29px" v-for="v in schedule_codes" :key="v">
                      <div class="form-row">
                        <label>Tittle: {{v.title}}</label>
                      </div>
                      <div class="form-row">
                         <VueCodeEditor
                          :value="v.code"
                          @init="editorInit"
                          lang="javascript"
                          theme="monokai"
                          width="100%"
                          height="200px"
                          :options="{
                            enableBasicAutocompletion: true,
                            enableLiveAutocompletion: true,
                            fontSize: 14,
                            highlightActiveLine: true,
                            enableSnippets: true,
                            showLineNumbers: true,
                            tabSize: 2,
                            showPrintMargin: true,
                            showGutter: true,
                          }"
                          :commands="[
                              {
                                name: 'save',
                                bindKey: { win: 'Ctrl-s', mac: 'Command-s' },
                                exec: null,
                                readOnly: true,
                              },
                          ]"
                          />
                      </div>
                    </div>
                    <br>
                    <br>
                    <div class="col-md-12"><p><br><br></p></div>
                    <div class="form-submit mb-5">
                         <!-- <button class="btn btn-md btn-success" type="submit">Submit</button> -->
                 </div>
                 <div class="col-md-12"><p><br><br></p></div>
            </b-form>
                </div>
              </div>
            </div>
      </div>
        <!-- end tab -->
      <!-- /.box-body -->
    </div>
    <!-- /.box -->
  </section>
</template>

<script>
import axios from 'axios'
import { BaseURLV3 } from '../shared/classes'
import * as Cookies from 'js-cookie'
import router from '../router/index'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import Vue from 'vue'
import $ from 'jquery'
import VueCodeEditor from 'vue2-code-editor'
// import Jspdf from 'jspdf'
import html2pdf from 'html2pdf.js'
// import { makePDF } from 'multi-page-html2pdf'
// import html2canvas from 'html2canvas'
// import { Carousel, Slide } from 'vue-carousel'
import moment from 'moment'
Vue.use(moment)
const formShape = {
  level: '',
  interview: '',
  jun_level: '',
  mid_level: '',
  sen_level: '',
  lead: '',
  architect_level: '',
  commun_level_comments: '',
  technical_obser: '',
  anal_prosolving: '',
  attitude: '',
  clar_answer: '',
  recommended_for: '',
  other_comments: '',
  TDD_code: '',
  client_name: ''
}
const formShape2 = {
  comments: '',
  comments2: '',
  comments3: '',
  comments4: ''
}
const formShape3 = {
  remarks: '',
  remarks2: '',
  remarks3: '',
  remarks4: '',
  remarks5: ''
}
export default {
  name: 'addFeedback',
  data () {
    return {
      form: Object.assign({}, formShape),
      form2: Object.assign({}, formShape2),
      form3: Object.assign({}, formShape3),
      picked: 'Speaks with limited fluency, irregular grammar and carries a distinct accent',
      files: [],
      Files: [],
      clientError: false,
      tskills: '',
      manskills: '',
      rolelist: '',
      fid: '',
      sid: Cookies.get('sid'),
      comm_level_rating: 0,
      scheduleDetails: [],
      postDetails: [],
      feedbackDetail: [],
      schedule_codes: [],
      schedule_id: '',
      config: {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      }
    //   techskillta:[
    //    {
    //   textarea1: '',
    //    }
    //  ],
    //  manskillta:[
    //    {
    //   textarea: '',
    //    }
    //  ]
    }
  },
  computed: {
    isValid () {
      return !this.$v.form.$anyError
    },
    isDirty () {
      return this.$v.form.$anyDirty
    },
    invCheck () {
      return 'You must accept before submitting'
    }
  },
  mixins: [validationMixin],
  validations: {
    form: {
      level: {
        required
      },
      interview: {
        required
      },
      jun_level: {
        required
      },
      mid_level: {
        required
      },
      sen_level: {
        required
      },
      lead: {
        required
      },
      architect_level: {
        required
      },
      commun_level_comments: {
        required
      },
      technical_obser: {
        required
      },
      anal_prosolving: {
        required
      },
      attitude: {
        required
      },
      clar_answer: {
        required
      },
      recommended_for: {
        required
      },
      other_comments: {
        required
      },
      TDD_code: {
        required
      },
      client_name: {}
    },
    form2: {
      comments: {
        required
      },
      comments2: {
        required
      },
      comments3: {
        required
      },
      comments4: {
        required
      }
    },
    form3: {
      remarks: {
        required
      },
      remarks2: {
        required
      },
      remarks3: {
        required
      },
      remarks4: {
        required
      },
      remarks5: {
        required
      }
    }
  },
  components: {
    VueCodeEditor
  },
  created () {
    this.schedule_id = this.$route.params.id
    this.getFeedbackDetails()
    this.getFetchrolename()
    this.getscheduleDetails()
  },
  methods: {
    Download () {
      // const data = Object.assign({}, this.$refs)
      // html2pdf(data.document, {
      //   margin: {
      //     bottom: 1
      //   },
      //   filename: 'document.pdf',
      //   image: {
      //     type: 'jpeg',
      //     quality: 2
      //   },
      //   html2canvas: {
      //     dpi: 300,
      //     letterRendering: true
      //   },
      //   jsPDF: {
      //     unit: 'in',
      //     format: 'letter',
      //     orientation: 'landscape'
      //   }
      // })
      // data.hide.setAttribute('hidden', 'hidden')
      const element = document.getElementById('pdfdocument')
      const opt = {
        margin: 1,
        filename: 'feedback.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 3 },
        pagebreak: { before: '.newPage', after: '.after', avoid: '.avoid' },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
      }
      html2pdf().from(element).set(opt).save()
    },
    getscheduleDetails () {
      console.log(this.$route.params.id)
      axios.get(BaseURLV3 + '/dashboard/get_schedule_detail/' + this.$route.params.id, this.config).then(response => {
        this.scheduleDetails = response.data.scheduleList[0]
        // this.getPostDetails(this.scheduleDetails.post_id)
      }).catch(e => {
      })
    },
    getPostDetails (id) {
      axios.get(BaseURLV3 + '/dashboard/get_post_details_web/' + id, this.config).then(response => {
        this.postDetails = response.data.postInfo[0]
      }).catch(e => {
      })
    },
    fileUpload (e) {
      console.log('file', e.target.files)
      this.files = e.target.files
      this.Files = e.target.files[0]
      console.log('Files', this.Files)
      $('.custom-file-upload').removeClass('is-invalid')
      for (let k = 0; k < e.target.files.length; k++) {
        if (e.target.files[k].type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || e.target.files[k].type === 'application/pdf' || e.target.files[k].type === 'application/msword') {
          if (e.target.files[k].size < '2000001') {
            this.files.push(e.target.files[k])
          }
        }
      }
      $('#file').val('')
      console.log(this.files)
      const formData = new FormData()

      formData.append('image', this.Files)
      axios.post(BaseURLV3 + '/dashboard/upload_candidate_image/1',
        formData, this.config).then(response => {
        console.log(response)
      }).catch(e => {
        console.log(e)
      })
    },
    onChange (event) {
      this.picked = event.target.value
      console.log('this.picked', this.picked)
    },
    removeUploading (index) {
      this.Files = ''
      console.log(this.files)
    },
    changepass () {
      this.olderror = false
    },
    getdate (x) {
      const d = moment().add(x, 'days')
      return moment(d).format('DD MMM YYYY')
    },
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    chkState2 (val) {
      const field = this.$v.form2[val]
      return !field.$dirty || !field.$invalid
    },
    chkState3 (val) {
      const field = this.$v.form3[val]
      return !field.$dirty || !field.$invalid
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })
      return focused
    },
    removeElement (row) {
      const index = this.rows.indexOf(row)
      this.rows.splice(index, 1)
    },
    changecomments () {
      const len = this.$v.form2.comments.$model.length
      const c2len = this.$v.form2.comments2.$model.length
      const c3len = this.$v.form2.comments3.$model.length
      const c4len = this.$v.form2.comments4.$model.length
      console.log('len....', len)
      if (len < '1' || c2len < '1' || c3len < '1' || c4len < '1') {
        this.clientError = true
      } else {
        this.clientError = false
      }
    },
    changeremarks () {
      const remlen = this.$v.form3.remarks.$model.length
      const rem2len = this.$v.form3.remarks2.$model.length
      const rem3len = this.$v.form3.remarks3.$model.length
      const rem4len = this.$v.form3.remarks4.$model.length
      const rem5len = this.$v.form3.remarks5.$model.length
      if (remlen < '1' || rem2len < '1' || rem3len < '1' || rem4len < '1' || rem5len < '1') {
        this.clientError = true
      } else {
        this.clientError = false
      }
    },
    setRating (rating) {
      this.comm_level_rating = rating
      console.log('this.rating', this.rating)
    },
    changeloecomments () {
      const junlen = this.$v.form.jun_level.$model.length
      const midlen = this.$v.form.mid_level.$model.length
      const senlen = this.$v.form.sen_level.$model.length
      const archlevel = this.$v.form.architect_level.$model.length

      if (junlen < '1' || midlen < '1' || senlen < '1' || archlevel < '1') {
        this.clientError = true
      } else {
        this.clientError = false
      }
    },
    changecommentsrecommen () {
      const crecommenlen = this.$v.form.technical_obser.$model.length
      const crecommenlen2len = this.$v.form.anal_prosolving.$model.length
      const crecommenlen3len = this.$v.form.attitude.$model.length
      const crecommenlen4len = this.$v.form.clar_answer.$model.length
      if (crecommenlen < '1' || crecommenlen2len < '1' || crecommenlen3len < '1' || crecommenlen4len < '1') {
        this.clientError = true
      } else {
        this.clientError = false
      }
    },
    changefinalrecommen () {
      const recommendedlen = this.$v.form.recommended_for.$model.length
      const othercommentslen = this.$v.form.other_comments.$model.length
      const tddcodelen = this.$v.form.TDD_code.$model.length

      if (recommendedlen < '1' || othercommentslen < '1' || tddcodelen < '1') {
        this.clientError = true
      } else {
        this.clientError = false
      }
    },
    changentcomments () {
      const communlevelcomment = this.$v.form.commun_level_comments.$model.length
      if (communlevelcomment < '1') {
        this.clientError = true
      } else {
        this.clientError = false
      }
    },
    tsChange (index) {
      console.log(index)
      this.tskills[index].required = false
      console.log(this.tskills[index])
    },
    mansChange (index) {
      console.log(index)
      this.manskills[index].required = false
      console.log(this.manskills[index])
    },
    getFetchrolename () {
      const mainurl = '/dashboard/get_role_template'
      axios.get(`${BaseURLV3}${mainurl}`, this.config).then(response => {
        console.log(response.data)
        console.log(response)
        var data = response.data.role_template_list
        console.log('rolename', data)
        this.rolelist = data[0].role_name
      }).catch(e => {
        console.log(e)
      })
    },
    getFeedbackDetails () {
      const mainurl = BaseURLV3 + '/interviewer/' + this.schedule_id + '/feedback'
      axios.get(`${mainurl}`, this.config).then(response => {
        this.schedule_codes = response.data.schedule.code
      }).catch(e => {
        console.log(e)
      })
    },
    navigation (tabs) {
      router.push({ name: tabs })
    }
  }
}
</script>

<style scoped>
.products-list .item:hover {
  border-left: 3px solid #ffffff;
  background-color: #ffffff;
  cursor: pointer;
}
a:hover, a:active, a:focus {
  outline: none;
  text-decoration: none;
  color: #5bad2b;
}
.errorshow {
  background-color: #ff000047;
  padding: 5px;
  color: #dd4b39 !important;
}
.post li.active {
  background-color: #5bad2b !important;
  color: white !important;
  border: 0px !important;
}
.sideborder {
  border-right: 1px solid #cccccc52;
  min-height: 700px;
  height: 100%;
}
span.field-icon {
  position: absolute;
  display: inline-block;
  cursor: pointer;
  right: 2.5rem;
  top: 0.7rem;
  z-index: 2;
  margin-top: 4px;
}
.nav-stacked>li.active>a, .nav-stacked>li.active>a:hover {
    background: transparent;
    color:white;
    border-top: 0;
    border-left-color: #5bad2b ;
}
.ml-20 {
  margin-right: 20px;
}
.ml-36 {
  margin-right: 36px;
}
.p-5 {
  padding: 5px;
}
.container {
  display: block;
  position: relative;
  padding-left: 25px;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default radio button */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #eee;
  border-radius: 50%;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the radio button is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: #2196F3;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.container .checkmark:after {
  top: 6px;
  left: 6px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: white;
}
.download-pdf {
  float: right;
  padding: 0px;
  padding-bottom: 15px;
}
</style>
